<script>
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
import {performanceConfig_detailList, performanceConfig_updatePerformanceDetail} from "@/lib/request";
export default {
  name: 'setting',
  data() {
    return {
      innerLoading:false,
      isRestoring:false,
      showMonthFlag:false,
      showMonthValue:'',
      monthList: [
        {name: ''},
        {name: ''},
      ],
      showReviewFlag: false,
      showReviewValue: '',
      areaList: [
        {name: '拉萨市'},
        // {name: '日喀则市'},
        // {name: '昌都市'},
        {name: '阿里地区'},
        {name: '那曲市'},
        {name: '山南市'},
        {name: '林芝市'}
      ],
      areaShow: false,
      showAreaFlag: false,
      showAreaValue: '',
      areaItemList: [
        {name: '东郊片区'},
        {name: '北郊片区'},
        {name: '柳梧片区'},
        {name: '堆龙片区'},
      ],
      tipsFlag: false,
      listDefValues: [
        {
          title: '加分项',
          icon: 'add-o',
          list: [
            {
              type: 'radio',
              title: "通报表扬",
              flag: true,
              name: 'commendation',
              icon: 'info',
              checked: false,
              content: "片区内网点形象建设、新渠道拓展、营销宣传等工作表现突出，被通报表扬或作为示范样板进行推广的（以区中心文件为准）。",
              listChild: [
                {name: '有', type: 1},
                {name: '无', type: 0},
              ],
              value: '',
            }, {
              type: 'radio',
              flag: false,
              title: "团队协作",
              name: 'teamwork',
              icon: 'info',
              checked: false,
              content: "中福彩组织的比赛或活动获奖：一等奖加15分，二等奖加10分，三等奖加5分。区福彩中心组织的比赛或活动获奖：一等奖加10分，二等奖加5分，三等奖加2分。",
              listChild: [
                {name: '15分', type: 15},
                {name: '10分', type: 10},
                {name: '5分', type: 5},
                {name: '2分', type: 2},
                {name: '无', type: 0},
              ],
              value: '',
            }, {
              type: 'radio',
              flag: false,
              title: "营销宣传",
              name: 'marketing',
              icon: 'info',
              checked: false,
              content: "主动在片区开展营销宣传活动，并获得良好效果加10分；配合区福彩中心营销宣传活动，加5分。",
              listChild: [
                {name: '10分', type: 10},
                {name: '5分', type: 5},
                {name: '无', type: 0},
              ],
              value: '',
            }, {
              type: 'radio',
              flag: false,
              title: "内容贡献",
              name: 'contentContribution',
              icon: 'info',
              checked: false,
              content: "营销宣传稿件/短视频被国家级媒体（中福彩中心、国家彩票等）采用的加10分；被自治区或拉萨市媒体（如西藏商报、拉萨融媒）采用的加5分；被区福彩中心官方媒体采用的加2分。",
              listChild: [
                {name: '10分', type: 10},
                {name: '5分', type: 5},
                {name: '2分', type: 2},
                {name: '无', type: 0},
              ],
              value: '',
            }
          ]
        }, {
          title: '扣分项',
          icon: 'failure',
          list: [
            {
              type: 'radio',
              flag: true,
              title: "重大风险",
              name: 'majorRisk',
              icon: 'info',
              checked: false,
              content: "因管理或工作疏忽导致群体投诉、媒体曝光、引发舆情等。",
              listChild: [
                {name: '有', type: 1},
                {name: '无', type: 0},
              ],
              value: '',
            }, {
              type: 'text',
              flag: true,
              title: "失信次数",
              name: 'dishonestCount',
              icon: 'info',
              checked: false,
              content: "虚假填写巡检记录、物资领取发放记录等，出现其他有违诚实信用的情况。",
              value: '',
            }, {
              type: 'text',
              flag: false,
              title: "协作差次数",
              name: 'poorCooperationCount',
              icon: 'info',
              checked: false,
              content: "因个人原因影响其他部门工作（如财务对账延误、市场活动配合不力）。",
              value: '',
            }, {
              type: 'text',
              flag: true,
              title: "工作失职",
              name: 'salesViolationSiteCount',
              icon: 'info',
              checked: false,
              content: "专管员在销售网点日常管理中工作失职，在区中心巡检、专项监督检查、“神秘顾客”暗访调查等发现销售网点转借、出租、出售代销证，未按规定在显著位置展示代销证，未按规定张贴提示、警示标语，摆放老虎机、赌博机等疑似赌博设备，投注专用设备擅自外接第三方设备，存放易燃、易爆、有毒危险品，乱拉乱接电线、停放电动车或为电动车充电，擅自利用互联网售彩，向未成年人售彩或兑奖，销售伪造、变造彩票，私自泄露中奖者个人信息等情况。",
              value: '',
            }, {
              type: 'text',
              flag: true,
              title: "违规操作",
              name: 'violationCount',
              icon: 'info',
              checked: false,
              content: "专管员在销售网点设立、变更、迁移、撤销中存在违规操作情况。",
              value: '',
            }, {
              type: 'text',
              flag: false,
              title: "投诉超时次数",
              name: 'complaintTimeoutCount',
              icon: 'info',
              checked: false,
              content: "未在48小时内响应并解决有效投诉；同一问题重复投诉。",
              value: '',
            }, {
              type: 'text',
              flag: true,
              title: "交办逾期数",
              name: 'overdueTaskCount',
              icon: 'info',
              checked: false,
              content: "未按期完成区中心交办的工作任务的（正式文件或中心业务部门通知、网点管理平台工单均可作为交办工作任务及其期限依据）。",
              value: '',
            }
          ]
        }
      ],
      rateValue: null,

      fullAttendanceDays: null,
      baseSalary: null,
      siteManagementUnitPrice: null,
      cityPlanSales: null,
      cityPlanSalesObj: {}

    }
  },
  components: {
    InnerLoading,
  },
  watch: {
    // 监控参数变化
    searchParams: function (newVal, oldVal) {
      this.getListData();
    },
  },
  computed: {
    // 监控参数变化更新
    searchParams() {
      return {
        "month": this.showMonthValue,
        "city": this.showReviewValue,
        "area": this.showAreaValue,//'',//
      }
    },
  },
  created() {
    // 获取本月
    const d = new Date();
    this.monthList[0].name = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    // 上个月的日期
    this.monthList[1].name = this.getLastMonth();
    this.showMonthValue = this.monthList[0].name;
    // 地市
    this.showReviewValue = this.areaList[0].name;
    if (this.showReviewValue === '拉萨市') {
      this.areaShow = true;
      this.areaItemList = [
        {name: '东郊片区'},
        {name: '北郊片区'},
        {name: '柳梧片区'},
        {name: '堆龙片区'},
      ]
      this.showAreaValue = this.areaItemList[0].name;
    } else if (this.showReviewValue === '林芝市') {
      // this.areaShow = true;
      // this.areaItemList = [
      //   {name: '一片区'},
      //   {name: '二片区'},
      //   {name: '三片区'},
      //   {name: '四片区'},
      // ]
      // this.showAreaValue = this.areaItemList[0].name;
    }
  },
  methods: {
    unitConvert(num) {
      let moneyUnits = ["元", "万元", "亿元", "万亿"];
      let dividend = 10000;
      let curentNum = num;
      //转换数字
      let curentUnit = moneyUnits[0]
      //转换单位
      for (let i = 0; i < 4; i++) {
        curentUnit = moneyUnits[i]
        if (this.strNumSize(curentNum) < 5) {
          break;
        }
        curentNum = curentNum / dividend
      }
      let m = {num: 0, unit: ""}
      m.num = curentNum.toFixed(2)
      m.unit = curentUnit
      return m
    },
    strNumSize(tempNum) {
      let stringNum = tempNum.toString()
      let index = stringNum.indexOf(".")
      let newNum = stringNum
      if (index !== -1) {
        newNum = stringNum.substring(0, index)
      }
      return newNum.length
    },
    getLastMonth() {
      const today = new Date();
      let lastMonth = new Date(today);
      lastMonth.setMonth(lastMonth.getMonth() - 1); // 减去一个月

      let year = lastMonth.getFullYear(); // 获取年份
      let month = lastMonth.getMonth() + 1; // 获取月份，月份是从0开始的，所以要加1

      // 格式化月份为两位数
      month = month < 10 ? '0' + month : month;

      return `${year}-${month}`;
    },
    // 输入框校验
    getRules(field) {
      return [
        {
          validator: (val) => this.validateRequired(val, field.name),
          message: `请输入${field.name}`
        }
      ]
    },
    validateRequired(val) {
      return !(val === null || val === undefined || val === '');
    },
    getListData() {
      if (!this.searchParams.month) {
        return false;
      }
      if (!this.searchParams.city) {
        return false;
      }
      if (this.searchParams.city === '拉萨市') {
        if (!this.searchParams.area) {
          return false;
        }
      }

      this.innerLoading = true;
      performanceConfig_detailList(this.searchParams).then((res) => {
        if (res) {
          this.innerLoading = false;
          if (!res.data) {
            this.$toast('暂无数据！');
            return false;
          }
          if (res.data.code === 200) {
            if (res.data.data.length <= 0) {
              // this.$toast('数据为空！');
              return false;
            }
            this.queryObj = res.data.data[0];
            this.fullAttendanceDays = res.data.data[0].fullAttendanceDays;
            this.baseSalary = res.data.data[0].baseSalary;
            this.siteManagementUnitPrice = res.data.data[0].siteManagementUnitPrice;
            if (res.data.data[0].cityPlanSales) {
              this.cityPlanSales = Number(res.data.data[0].cityPlanSales) / 10000;
            }
            this.cityPlanSalesObj = this.unitConvert(Number(res.data.data[0].cityPlanSales));
            this.listDefValues.map((v) => {
              v.list.map((i) => {
                // 积分项
                if (i.name === 'commendation') {
                  // 通报表扬：commendation
                  i.value = res.data.data[0].commendation;
                } else if (i.name === 'teamwork') {
                  // 团队协作:teamwork
                  i.value = res.data.data[0].teamwork;
                } else if (i.name === 'marketing') {
                  // 营销宣传:marketing
                  i.value = res.data.data[0].marketing;
                } else if (i.name === 'contentContribution') {
                  // 内容贡献:contentContribution
                  i.value = res.data.data[0].contentContribution;
                }
                    // 扣分项
                // 重大风险 ：majorRisk
                else if (i.name === 'majorRisk') {
                  i.value = res.data.data[0].majorRisk;
                } else if (i.name === 'dishonestCount') {
                  // 失信次数:dishonestCount
                  i.value = res.data.data[0].dishonestCount;
                } else if (i.name === 'poorCooperationCount') {
                  // 协作差次数:poorCooperationCount
                  i.value = res.data.data[0].poorCooperationCount;
                } else if (i.name === 'salesViolationSiteCount') {
                  // 工作失职:salesViolationSiteCount
                  i.value = res.data.data[0].salesViolationSiteCount;
                } else if (i.name === 'violationCount') {
                  // 违规操作:violationCount
                  i.value = res.data.data[0].violationCount;
                } else if (i.name === 'complaintTimeoutCount') {
                  // 投诉超时次数:complaintTimeoutCount
                  i.value = res.data.data[0].complaintTimeoutCount;
                } else if (i.name === 'overdueTaskCount') {
                  // 交办逾期数:overdueTaskCount
                  i.value = res.data.data[0].overdueTaskCount;
                }
              });
            });
          } else {
            this.$toast(res.data.msg);
            return false;
          }
        }
      });
    },
    // 地市
    onReviewType(value) {
      this.showReviewValue = value.name;
      // this.areaShow = value.name === '拉萨市';
      this.showReviewFlag = false;
      if (this.showReviewValue === '拉萨市') {
        this.areaShow = true;
        this.areaItemList = [
          {name: '东郊片区'},
          {name: '北郊片区'},
          {name: '柳梧片区'},
          {name: '堆龙片区'},
        ]
        // 片区
        this.showAreaValue = this.areaItemList[0].name;
        // }
        // else if(this.showReviewValue==='林芝市'){
        // this.areaShow = true;
        // this.areaItemList = [
        //   {name: '一片区'},
        //   {name: '二片区'},
        //   {name: '三片区'},
        //   {name: '四片区'},
        // ]
        // // 片区
        // this.showAreaValue = this.areaItemList[0].name;
      } else {
        // 不显示片区
        this.showAreaValue = '';
        this.areaShow = false;
      }

    },
    // 片区
    onAreaItemType(value) {
      this.showAreaValue = value.name;
      this.showAreaFlag = false;
    },
    // 月份
    onMonthType(value) {
      this.showMonthValue = value.name;
      this.showMonthFlag = false;
    },
    getCheck(item, v) {
      v.checked = !v.checked;
      item.list.map((val) => {
        if (v.title === val.title) {

        } else {
          val.checked = false;
        }
      })
    },
    getOnNumberTime() {
      if (this.isRestoring) return;
      this.isRestoring = true;
      // 延时确保在键盘完全收起后执行
      setTimeout(() => {
        window.scrollTo({
          top: this.savedScrollPosition,
          behavior: 'smooth' // 平滑滚动，可选
        });
        this.isRestoring = false;
      }, 100); // 这个时间可以根据需要调整，通常200-400ms
    },
    saveScrollPosition() {
      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    },
    getCancel() {
      this.tipsFlag = false;
      if (!this.queryObj?.baseSalary) {
        return false;
      }
      this.baseSalary = this.queryObj.baseSalary;
      this.siteManagementUnitPrice = this.queryObj.siteManagementUnitPrice;
      this.cityPlanSales = this.queryObj.cityPlanSales;
      this.fullAttendanceDays = this.queryObj.fullAttendanceDays;
    },
    //   全局参数设置
    getSetSubmit() {
      if (!this.queryObj?.id) {
        this.$toast('id不存在，无法提交修改！');
        return false;
      }
      let params = {
        "id": this.queryObj.id,
        "month": this.showMonthValue,
        "city": this.showReviewValue,
        "area": this.showAreaValue,//'',//
        "baseSalary": Number(this.baseSalary),
        "siteManagementUnitPrice": Number(this.siteManagementUnitPrice),
        // "cityPlanSales": Number(this.cityPlanSales),
        "fullAttendanceDays": Number(this.fullAttendanceDays),//全勤天数
        // "badImageSiteCount": 0,//站点形象或设备不合格网点数
      }
      performanceConfig_updatePerformanceDetail(params).then((res) => {
        if (res) {
          if (!res.data) {
            this.$toast('res.data不存在');
            return false
          }
          if (res.data.code === 200) {
            this.tipsFlag = false;
            this.getListData();
            this.$toast.success('设置成功！');
          } else {
            this.$toast.success(res.data.msg);
          }
        }
      });
    },
    // 提交
    getCommit() {
      if (!this.queryObj?.id) {
        this.$toast('id不存在，无法提交修改！');
        return false;
      }
      let params = {
        "id": this.queryObj.id,
        "month": this.showMonthValue,
        "city": this.showReviewValue,
        "area": this.showAreaValue,//'',//
        "baseSalary": Number(this.baseSalary),
        "siteManagementUnitPrice": Number(this.siteManagementUnitPrice),
        // "cityPlanSales": Number(this.cityPlanSales),
        "fullAttendanceDays": Number(this.fullAttendanceDays),//全勤天数
        "badImageSiteCount": 0,//站点形象或设备不合格网点数
      }
      // 加分项
      const result = this.listDefValues[0].list.reduce((obj, item) => {
        obj[item.name] = Number(item.value);
        return obj;
      }, {});
      // 扣分项
      const result1 = this.listDefValues[1].list.reduce((obj, item) => {
        obj[item.name] = Number(item.value);
        return obj;
      }, {});
      const params_return = {
        ...params, ...result, ...result1
      }
      /*"fullAttendanceDays": 22,//全勤天数
      "badImageSiteCount": 0,//站点形象或设备不合格网点数*/
      // return false;
      performanceConfig_updatePerformanceDetail(params_return).then((res) => {
        if (res) {
          if (!res.data) {
            this.$toast('res.data不存在');
            return false
          }
          if (res.data.code === 200) {
            this.getListData();
            this.$toast.success('设置成功！');
          } else {
            this.$toast.success(res.data.msg);
          }
        }
      });
    },
  }
}
</script>
<template>
  <div class="tech-content-no">
    <!--    加载中...-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--    基本信息    -->
    <div class="card">
      <div class="label-title">
        <van-icon name="info-o"/>
        基本信息
      </div>
      <div class="stack-group">
        <div class="t-bound">
          <div class="t-bound-e">月份<span>*</span></div>
          <div class="t-bound-t">
            <van-field
                v-model="showMonthValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择月份"
                @click="showMonthFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
        <div class="t-bound">
          <div class="t-bound-e">地市<span>*</span></div>
          <div class="t-bound-t">
            <van-field
                v-model="showReviewValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择地市"
                @click="showReviewFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
        <!--        <div class="t-bound">-->
        <!--          <div class="t-bound-e">时间<span>*</span></div>-->
        <!--          <div class="t-bound-t">-->
        <!--            <van-radio-group v-model="radio" direction="horizontal">-->
        <!--              <van-radio name="1">上月(2025年12月)</van-radio>-->
        <!--              <van-radio name="2">本月(2026年01月)</van-radio>-->
        <!--            </van-radio-group>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="stack-group" v-if="areaShow">
        <div class="t-bound">
          <div class="t-bound-e">片区<span>*</span></div>
          <div class="t-bound-t">
            <van-field
                v-model="showAreaValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择片区"
                @click="showAreaFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
        <div class="t-bound">
          <div class="t-bound-e"><span style="color: transparent">全局参数设置</span></div>
          <div class="t-bound-t">
            <div class="label-button-t">
              <div class="label-bound" @click="tipsFlag=true">全局参数设置</div>
            </div>
          </div>
        </div>
      </div>
      <div class="label-button-t" v-if="!areaShow">
        <!--      <div class="label-button-t">-->
        <div class="label-bound" @click="tipsFlag=true">全局参数设置</div>
      </div>
    </div>
    <div v-if="showReviewValue!==''">
      <!--  服务满意度  -->
      <!--      <div class="card">-->
      <!--        <div class="rate-gr-title">服务满意度 <span>*</span></div>-->
      <!--        <div class="rate-group">-->
      <!--          <van-rate-->
      <!--              v-model="rateValue"-->
      <!--              :size="25"-->
      <!--              color="#ffd21e"-->
      <!--              void-icon="star"-->
      <!--              void-color="#eee"-->
      <!--          />-->
      <!--          <span>{{rateValue}}分</span>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    加分项        -->
      <div class="card" v-for="(item,index) in listDefValues" :key="index">
        <div class="label-title">
          <van-icon :name="item.icon"/>
          {{ item.title }}
        </div>
        <div class="label-group">
          <div :class="v.type==='radio'?'form-row-line':'form-row'" v-if="item.list.length>0" v-for="(v,k) in item.list"
               :key="k">
            <div class="form-group">
              <div class="t-bound" :class="v.type==='radio'?'':''" v-show="showReviewValue!=='拉萨市'?v.flag:true">
                <div class="t-bound-e">
                  {{ v.title }}
                  <!--                  <el-tooltip class="item" effect="dark" :content="v.content" placement="top-start">-->
                  <span @click="getCheck(item,v)"><van-icon :name="v.icon"/></span>
                  <!--                  </el-tooltip>-->
                </div>
                <div class="info-tooltip" v-show="v.checked">
                  <div class="info-tooltip-content">{{ v.content }}</div>
                </div>
                <div class="t-bound-t" v-if="v.type==='radio'">
                  <van-radio-group v-model="v.value" direction="horizontal">
                    <van-radio :name="val.type" v-for="(val,key) in v.listChild" :key="key">{{ val.name }}</van-radio>
                  </van-radio-group>
                </div>
                <div class="t-bound-t" v-if="v.type==='text'">
                  <van-field
                      v-model="v.value"
                      name=""
                      label=""
                      type="number"
                      placeholder=""
                      @focus="saveScrollPosition"
                      @change="getOnNumberTime()"
                  ></van-field>
                  次
                </div>
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <div class="label-button">
        <div class="label-commit" @click="getCommit">提交</div>
      </div>
    </div>
    <!--  地市  -->
    <van-popup v-model="showReviewFlag" position="bottom">
      <van-picker
          show-toolbar
          title="地市"
          :columns="areaList"
          value-key="name"
          :default-index="0"
          @confirm="onReviewType"
          @cancel="showReviewFlag = false"
      />
    </van-popup>
    <!--  片区  -->
    <van-popup v-model="showAreaFlag" position="bottom">
      <van-picker
          show-toolbar
          title="片区"
          :columns="areaItemList"
          value-key="name"
          :default-index="0"
          @confirm="onAreaItemType"
          @cancel="showAreaFlag = false"
      />
    </van-popup>
    <!--  月份  -->
    <van-popup v-model="showMonthFlag" position="bottom">
      <van-picker
          show-toolbar
          title="团队协作"
          :columns="monthList"
          value-key="name"
          :default-index="0"
          @confirm="onMonthType"
          @cancel="showMonthFlag = false"
      />
    </van-popup>
    <!--  全局配置  -->
    <van-popup v-model="tipsFlag" position="center" :close-on-click-overlay="false" :style="{width:'90%' }">
      <div class="inner-diag">
        <van-form @submit="getSetSubmit">
          <div class="title-had">
            <div class="fixed-close" @click="getCancel">&times;</div>
            <div class="section-title">全局参数设置</div>
          </div>
          <div class="tabs-group">
            <div class="t-bound">
              <div class="t-bound-e">全勤天数</div>
              <div class="t-bound-t">
                <van-field
                    v-model="fullAttendanceDays"
                    name=""
                    label=""
                    type="number"
                    :rules="getRules({name:'全勤天数'})"
                    placeholder="请输入全勤天数"
                ></van-field>
                天
              </div>
            </div>
            <div class="t-bound">
              <div class="t-bound-e">基本工资</div>
              <div class="t-bound-t">
                <van-field
                    v-model="baseSalary"
                    name=""
                    label=""
                    type="number"
                    :rules="getRules({name:'基本工资'})"
                    placeholder="请输入基本工资"
                ></van-field>
                元
              </div>
            </div>
            <div class="t-bound">
              <div class="t-bound-e">单个网点管理工资</div>
              <div class="t-bound-t">
                <van-field
                    v-model="siteManagementUnitPrice"
                    name=""
                    label=""
                    type="number"
                    :rules="getRules({name:'单个网点管理工资'})"
                    placeholder="请输入单个网点管理工资"
                ></van-field>
                元
              </div>
            </div>
            <div class="t-bound">
              <div class="t-bound-e">地市计划月销量</div>
              <div class="t-bound-t">
                <van-field
                    v-model="cityPlanSalesObj.num"
                    name=""
                    label=""
                    type="number"
                    readonly="readonly"
                    :rules="getRules({name:'地市计划月销量'})"
                    placeholder="请输入地市计划月销量"
                ></van-field>
                {{ cityPlanSalesObj.unit }}
              </div>
            </div>
          </div>
          <div class="form-buttons">
            <van-button class="erase" round block plain type="default" @click="getCancel"
                        style="background: #f5f5f5;border:none;"
                        native-type="button">取消
            </van-button>
            <van-button class="leg" round block type="primary" native-type="submit" style="border:none;">保存
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">
.tech-content-no {
  font-size: 28px;
  padding: 120px 20px 120px 20px;
  box-sizing: border-box;

  /deep/ .van-cell {
    padding: 15px 20px;
    font-size: 28px !important;
  }

  /deep/ .van-field__control {
    font-size: 28px !important;

  }

  .card {
    padding: 20px 30px;
  }

  .label-title {
    font-weight: bold;
    color: var(--primary-color);
    margin-bottom: 15px;
    padding-bottom: 8px;
    padding-left: 8px;
    border-bottom: 2px solid var(--primary-color);
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .rate-gr-title {
    font-weight: bold;
    padding-bottom: 20px;

    span {
      color: red;
    }
  }

  .rate-group {
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      margin-left: 20px;
    }
  }

  .label-group {
    padding-top: 20px;
    clear: both;

    .form-row-line {
      display: flex;
      flex-flow: column;
      width: 100%;
    }

    .form-row {
      display: flex;
      flex-flow: row;
      width: 50%;
      float: left;
    }

    .form-group {
      background: transparent;
      padding: 0;
      margin: 0;

      .t-bound {
        margin-bottom: 20px;

        .grant {
          color: transparent;
        }

        .t-bound-e {
          font-weight: bold;
          padding: 0 0 10px;
          position: relative;

          span {
            display: inline-block;
            vertical-align: middle;
            margin-left: 10px;
            color: #e62d2d;
          }

          .el-tooltip__popper {
            padding: 8px 10px;
            background: red;
          }

          .info-tooltip {
            position: absolute;
            left: 0;
            top: -150px;
            z-index: 10;
            background: #fff;
            border: 1px solid rgba(230, 45, 45, 0.2);
            border-radius: var(--border-radius-sm);
            padding: 12px;
            margin-bottom: 18px;
            font-size: 13px;
            color: var(--text-light);
            line-height: 1.6;
            box-shadow: var(--shadow-md);
            animation: fadeIn 0.3s ease;
          }

          .info-tooltip-content {
            position: relative;
            padding-left: 15px;
            font-size: 24px;
          }

          .info-tooltip-content:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background: var(--primary-color);
            border-radius: 2px;
          }
        }

        .info-tooltip {
          background: #fff;
          border: 1px solid rgba(230, 45, 45, 0.2);
          border-radius: var(--border-radius-sm);
          padding: 12px;
          margin-bottom: 18px;
          font-size: 13px;
          color: var(--text-light);
          line-height: 1.6;
          box-shadow: var(--shadow-md);
          animation: fadeIn 0.3s ease;
        }

        .info-tooltip-content {
          position: relative;
          padding-left: 15px;
          font-size: 24px;
        }

        .info-tooltip-content:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: var(--primary-color);
          border-radius: 2px;
        }

        .t-bound-t {
          display: flex;
          flex-direction: row;
          align-items: center;

          /deep/ .van-cell {
            width: 80%;
            background: #f9f9f9;
            border-radius: 10px;
            margin-right: 20px;
            border: 2px solid rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }

  .label-radio {
    padding-top: 20px;

  }

  .finish-group {
    .finish-group-title {
      color: #4caf50;
      padding: 10px 0;
    }

    .finish-group-list {
      .finish-box {
        display: inline-block;
        padding: 5px 0 5px 25px;
        border-radius: 50px;
        background: #4caf50;

        span {
          color: #fff;
        }

        .del {
          font-size: 40px;
          padding: 0 20px 0 30px;
        }
      }
    }
  }

  .label-button-t {
    width: 100%;

    .label-bound {
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, #4CAF50, #45a049);
    }
  }

  .stack-group {
    display: flex;
    flex-direction: row;
    gap: 18px;

    .t-bound {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-bottom: 20px;

      .grant {
        color: transparent;
      }

      .t-bound-e {
        padding: 0 0 10px;

        span {
          color: red;
        }
      }

      .t-bound-t {
        display: flex;
        flex-direction: row;
        align-items: center;

        .label-button-t {
          width: 100%;

          .label-bound {
            width: 100%;
            color: #fff;
            text-align: center;
            height: 80px;
            line-height: 80px;
            border-radius: 10px;
            background: linear-gradient(135deg, #4CAF50, #45a049);
          }
        }

        /deep/ .van-cell {
          //width: 80%;
          background: #f9f9f9;
          border-radius: 10px;
          margin-right: 20px;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  .label-stack {
    .label-stack-title {
      padding: 10px 0;

      span {
        display: inline-block;
        color: red;
        margin-left: 10px;
      }
    }

    .label-stack-text {
      border: 2px solid #ddd;
      border-radius: 10px;

      /deep/ .van-cell {
        border-radius: 10px;
      }
    }
  }

  .label-button {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 120px;
    padding: 20px 20px 0;
    background: #fff;
    width: 100%;

    .label-commit {
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
    }

    .label-bound {
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, #4CAF50, #45a049);
    }
  }

}

/deep/ .van-popup {
  background: transparent;
}

.inner-diag {
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  .title-had {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 40px 20px 0;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;

    .fixed-close {
      position: absolute;
      right: 50px;
      top: 19px;
      font-size: 50px;
      color: #999;
    }

    .section-title {
      font-size: 32px;
      background: #fff;
      padding-left: 10px;
    }
  }

  .form-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #e5e7eb;
    padding: 20px 20px;
    background: #fff;
    margin: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    //span{
    //  display:flex;
    //  justify-content: center;
    //  flex: 1;
    //  border: 1px solid #e5e7eb;;
    //  padding: 20px 35px;
    //  border-radius: 10px;
    //}
    .erase {
      background: #f3f4f6;
      color: #666;
    }

    .leg {
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
      color: white;
    }
  }

  .tabs-group {
    padding: 40px 30px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;

    .t-bound {
      margin-bottom: 20px;

      .t-bound-e {
        font-weight: bold;
        padding: 0 0 10px;

      }

      .t-bound-t {
        display: flex;
        flex-direction: row;
        align-items: center;

        /deep/ .van-cell {
          width: 86%;
          background: #f9f9f9;
          border-radius: 10px;
          margin-right: 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
    }

    span {
      color: #333;
      display: inline-block;
    }

    .con-app {
      color: red;
    }

    .pub {
      background: #f9fafb;
      padding: 30px 15px;
      border-radius: 12px;
      margin-bottom: 20px;
    }
  }
}
</style>